// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OgDE","icon":"styles_icon__b8iQu"};